var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import './patient-notification-list-card.css';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { PureComponent } from 'react';
import PatientNotificationListCardAPI from './patient-notification-list-card-api';
import { ReactComponent as CancelSVG } from '../../assets/images/icons/cancel.svg';
import { ReactComponent as CheckSVG } from '../../assets/images/icons/check.svg';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { Card } from '@philips-internal/oswald-ui-components';
let PatientNotificationListCard = class PatientNotificationListCard extends PureComponent {
    static { this.propTypes = {
        appointmentType: string,
        duration: string,
        endDate: string,
        examName: string,
        isRevised: string,
        localeValue: string,
        notificationStatus: string,
        notificationType: string,
        nrPrescricao: number,
        onClick: eventListener,
        releaseDate: string,
        releaseDateServer: string,
        resultDescription: string,
        scheduleStatus: string,
        sequence: number,
        statusCode: string
    }; }
    render() {
        const { onClick, examName, releaseDateServer, resultDescription, notificationStatus } = this.props;
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-notification-list-item', onClick: trigger(onClick, new ClickEvent()), width: 12, selectionType: SelectionType.NONE },
            React.createElement("div", { className: `card-status-bar status-${notificationStatus.toLowerCase()}` }),
            React.createElement("div", { className: 'card-icon' },
                this.getSvg(),
                '\u00A0'),
            React.createElement("div", { className: 'card-content' },
                React.createElement("div", { className: 'card-left-content' },
                    React.createElement("div", { className: 'card-left-info-content' },
                        React.createElement("div", { className: 'content-exame-name' },
                            releaseDateServer,
                            ' | ',
                            examName),
                        React.createElement("div", { className: 'content-physician-name' }, resultDescription))))));
    }
    getColor() {
        const { scheduleStatus } = this.props;
        switch (scheduleStatus) {
            case 'Canceled':
                return 'red';
            default:
                return 'green';
        }
    }
    getSvg() {
        const { scheduleStatus } = this.props;
        switch (scheduleStatus) {
            case 'Canceled':
                return React.createElement(CancelSVG, { className: `c-patient-term-card__color-${this.getColor()}` });
            default:
                return React.createElement(CheckSVG, { className: `c-patient-term-card__color-${this.getColor()}` });
        }
    }
};
PatientNotificationListCard = __decorate([
    AwesomeComponent({ api: PatientNotificationListCardAPI, type: ComponentType.DATA_DISPLAY })
], PatientNotificationListCard);
export default PatientNotificationListCard;
//# sourceMappingURL=patient-notification-list-card.js.map